Handlebars.registerPartial('partials/common/travel_managers/list-travel-manager-row', Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<tr>\n    <td>\n        <div class=\"label-text no-text-overflow truncate\" title=\""
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"first_name") : depth0), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"last_name") : depth0), depth0)) != null ? stack1 : "")
    + "\">\n            "
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"first_name") : depth0), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"last_name") : depth0), depth0)) != null ? stack1 : "")
    + "\n        </div>\n        <div class=\"label-text no-text-overflow email\">\n            <a class=\"travel-manager-contact\" href=\"mailto:"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"email") : depth0), depth0)) != null ? stack1 : "")
    + "\">"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"email") : depth0), depth0)) != null ? stack1 : "")
    + "</a>\n        </div>\n    </td>\n</tr>\n";
},"useData":true}));